/** Agent 对话列表与详情。字段与服务端 snake_case 响应同名透传。 */

import { llmHttp } from './http.js'

/**
 * @typedef {Object} LlmConversationListQuery
 * @property {string} since
 * @property {number} [page]
 * @property {number} [limit]
 * @property {string} [q]
 * @property {string} [agent_role]
 * @property {string} [sort]
 * @property {string} [order]
 */

/** @param {LlmConversationListQuery} query @returns {Promise<object>} */
export function listLlmConversations(query) {
  return llmHttp().get('/conversations', {
    query,
    routeId: 'llm.admin.conversations.list',
  })
}

/** @param {string[]} turnIds @returns {Promise<object>} */
export function findLlmTurnConversations(turnIds) {
  return llmHttp().post('/turn-conversations', {
    body: { turn_ids: turnIds },
    routeId: 'llm.admin.conversations.byTurns',
  })
}

/**
 * @param {string} runId
 * @param {string} conversationKey
 * @returns {Promise<object>}
 */
export function getLlmConversation(runId, conversationKey) {
  return llmHttp().get(
    `/conversations/${encodeURIComponent(runId)}/${encodeURIComponent(conversationKey)}`,
    { routeId: 'llm.admin.conversations.detail' },
  )
}

/**
 * @param {string} runId
 * @param {string} conversationKey
 * @param {string} turnId
 * @returns {Promise<object>}
 */
export function getLlmConversationVideoMatch(runId, conversationKey, turnId) {
  const path = [runId, conversationKey, turnId].map(encodeURIComponent)
  return llmHttp().get(
    `/conversations/${path[0]}/${path[1]}/turns/${path[2]}/video-match`,
    { routeId: 'llm.admin.conversations.videoMatch' },
  )
}

/** @param {string} runId @returns {Promise<object>} */
export function getLlmRunVideoMatch(runId) {
  return llmHttp().get(
    `/runs/${encodeURIComponent(runId)}/video-match`,
    { routeId: 'llm.admin.runs.videoMatch' },
  )
}
